const prod = {
  api: {
    baseUrl: 'https://perform-api.ibacos.com/',
    jsonNamespace: 'api/v1/',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
};

const stg = {
  api: {
    baseUrl: 'https://perform-api-stg.ibacos.org/',
    jsonNamespace: 'api/v1/',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
};

const dev = {
  api: {
    baseUrl: 'https://perform-api-dev.ibacos.org/',
    jsonNamespace: 'api/v1/',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
  wallter: {
    baseUrl: 'https://o3681u74i3.execute-api.us-east-2.amazonaws.com/wallter/',
    jsonNamespace: 'api/v1/',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
};

const sand = {
  api: {
    baseUrl: 'https://perform-api-test.ibacos.org/',
    jsonNamespace: 'api/v1/',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
  wallter: {
    baseUrl: 'https://perform-api-test.ibacos.org/',
    jsonNamespace: '',
    clientId: 2,
    clientSecret: 'Kp8d2EvYXvNXgZWTSKntlsZrAYaCJ7QOjSHHMCMI',
  },
};

const local = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    jsonNamespace: process.env.REACT_APP_API_JSON_NAMESPACE,
    clientId: process.env.REACT_APP_API_CLIENT_ID,
    clientSecret: process.env.REACT_APP_API_CLIENT_SECRET,
  },
  wallter: {
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    jsonNamespace: process.env.REACT_APP_API_JSON_NAMESPACE,
    clientId: process.env.REACT_APP_API_CLIENT_ID,
    clientSecret: process.env.REACT_APP_API_CLIENT_SECRET,
  },
};

let config = {};
switch (process.env.REACT_APP_ENV) {
  case 'prod':
    config = prod;
    break;
  case 'dev':
    config = dev;
    break;
  case 'sand':
    config = sand;
    break;
  case 'stg':
    config = stg;
    break;
  default:
    config = local;
    break;
}

export default config;
